import {MarkedAsReadData, NotificationDataWithUnreadCount} from '../../../../shared/NotificationTypes'
import {UINotificationPanelController} from './UINotificationPanelController'
import {AudioManager, AudioType} from '@colonist/audio'

export class UINotificationActionController {
    private readonly notificationPanel: UINotificationPanelController

    constructor(notificationPanel: UINotificationPanelController) {
        this.notificationPanel = notificationPanel
    }

    addNotificationsToPanel(notificationDataWithUnreadCount: NotificationDataWithUnreadCount) {
        this.notificationPanel.addNotifications(notificationDataWithUnreadCount.notifications)
        this.notificationPanel.displayNumberOfUnreadNotifications(notificationDataWithUnreadCount.unreadNotificationCount)

        if(notificationDataWithUnreadCount.isExistingNotifications) return
        AudioManager.play(AudioType.RoomSettingUpdated)
    }

    markNotificationAsRead(markedAsReadData: MarkedAsReadData) {
        this.notificationPanel.displayNumberOfUnreadNotifications(markedAsReadData.unreadNotificationCount)
        if(markedAsReadData.markAllAsRead) return this.notificationPanel.markAllNotificationsAsRead()
        if(markedAsReadData.notificationMarkedAsRead) return this.notificationPanel.markNotificationAsRead(markedAsReadData.notificationMarkedAsRead.id)
    }
}
